import { EFirstMessageActionTypes } from '../../actions/firstMessage';
import { TAppState } from '../../types/appState';
import { EFirstMessageStatus } from '../../types/firstMessageStatus';
import { TReduxActions } from '../../types/redux/actions';

export function firstMessageReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EFirstMessageActionTypes.Pending:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.Pending,
          },
        },
      };
    case EFirstMessageActionTypes.Sent:
      const { chatId, message } = action.payload.chat;

      if (!chatId || !message) {
        return state;
      }

      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.Sent,
          },
        },
      };
    case EFirstMessageActionTypes.NeedCaptcha:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.NeedCaptcha,
          },
        },
      };
    case EFirstMessageActionTypes.NeedConfirmPhone:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.NeedConfirmPhone,
          },
        },
      };
    case EFirstMessageActionTypes.ChatsBlocked:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.ChatsBlocked,
          },
        },
      };
    case EFirstMessageActionTypes.UserChatsDisabled:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.ChatsDisabled,
          },
        },
      };
    case EFirstMessageActionTypes.Failed:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.Failed,
          },
        },
      };

    case EFirstMessageActionTypes.ValidationError:
      return {
        ...state,
        openedChats: {
          ...state.openedChats,
          blob: {
            ...state.openedChats['blob'],
            firstMessageStatus: EFirstMessageStatus.ValidationError,
          },
        },
      };

    default:
      return state;
  }
}
